import { createSlice } from "@reduxjs/toolkit";

import { type PackageStateType } from "../interfaces";

const initialState: PackageStateType = {
  isLoading: false,
  packages: [],
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setPackageLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPackages: (state, action) => {
      state.packages = action.payload;
    },
  },
});

export const { setPackageLoading, setPackages } = packageSlice.actions;
export default packageSlice.reducer;
